module.exports = __webpack_public_path__ + "img/dgslg-currency-guide-fr-1.7ead9321.png";